angular.module 'zc.commonApi'

.factory 'TagNonExistingUrls', (FacadeV2) ->
  class TagNonExistingUrls
    @findOne: (paths) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/tag_non_existing_urls",
        params:
          match: {}
      .then (results) ->
        return results.data?[0]



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/tag_non_existing_urls.service.js.coffee